var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"m14.03 5.03-7 7a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 3.47 3.47 6.47-6.47z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }